<template>
	<sidebar-menu v-if="sidebarToggler" :menu="filteredRoutes" :width="'230px'" :showOneChild="true" :collapsed="collapsed" :hideToggle="true" :rtl="true" @update:collapsed="onToggleCollapse" @item-click="onItemClick">
		<template v-slot:header>
			<div :class="[collapsed ? 'text-center' : 'text-left', 'p-2']">
				<i class="toggler fal fa-chevron-right" :class="{ 'collapsed': collapsed }" @click="toggleCollapsed"></i>
			</div>
			<div class="navbar-header">
				<div class="brand-box">
					<div class="logo-container">
						<nk-image :title="`${$t('install.customer.f.customerCode')}: ${userAccounts.customerCode}`" :modelValue="logoWhite" :options="brandImageOptions" />
					</div>
				</div>
				<div class="search-box">
					<icon icon="search" />
					<nk-input v-model="searchKeyword" class="nk-search" :options="inputOptions" ref="searchInput" @focus="() => isFocused = true" @blur="() => isFocused = false"></nk-input>
				</div>
			</div>
		</template>

	</sidebar-menu>
</template>
<script>
	import _ from 'lodash'
	import $sc from '~/plugins/shortcut.collection.js'
	import $ from 'jquery'
	import { routes, findRoute } from '~/statics/routes'
	import { SidebarMenu } from 'vue-sidebar-menu'
	import { post } from '~/plugins/nikan-api'
	import Endpoints from '@nikan/endpoints'
	import 'vue-sidebar-menu/dist/vue-sidebar-menu.css'
	import dynamicReportInstance from '@/plugins/dynamic-report'
	import { markRaw } from 'vue'
	import { mapGetters } from 'vuex'
	import logoWhite from '@/assets/logo-white.png'

	export default {
		props: {
			selectedItem: { type: Object },
			focusedItem: { type: Object },
			openedItem: { type: Object },
			hash: {},
			parentEl: {
				type: Function,
				default: () => { }
			}
		},
		components: {
			SidebarMenu
		},
		emits: ['navigate', 'executeFunction', 'openedItemChanged', 'focusedItemChanged'],
		data() {
			return {
				logoWhite,
				sidebarToggler: false,
				routes,
				collapsed: false,
				searchKeyword: null,
				isFocused: false,
				isOpening: false,
				inputOptions: {
					mode: 'text',
					placeholder: 'جستجو...'
				},
				brandImageOptions: {
					width: 60,
					height: 60
				}
			}
		},
		computed: {
			...mapGetters({
				'userAccounts': 'useraccount/currentUserDetails'
			}),
			filteredRoutes() {
				const filterChild = (list) => {
					return list.reduce((a, c) => {
						if (c.items) a = [...a, ...filterChild(c.items)]
						else a.push(c)
						return a
					}, [])
				}
				const routes = _.cloneDeep(this.routes)
				let items = this.searchKeyword ? filterChild(routes) : routes

				items = _.uniqBy(items, 'id')

				// User Access
				this.routesAccessChecker(items)

				// Search
				const isInChild = (list) => {

					if (!list || !list.length) {
						return false
					}

					for (let mi of list) {
						if (mi.menu.indexOf(this.searchKeyword) > -1) {
							return true
						} else if (isInChild(mi.items)) {
							return true
						}
					}

					return false
				}
				if (this.searchKeyword && this.searchKeyword !== '') {
					const keywords = this.searchKeyword.split(' ')

					const isKeywordInText = (route, keyword) => route.menu.indexOf(keyword) > -1 || isInChild(route.items) || route.parentName?.indexOf(keyword) > -1

					items = items.filter((x) => {
						return keywords.map(keyword => isKeywordInText(x, keyword)).every(status => status === true)
					})
				}

				const changeFormat = (item) => {
					delete item.component
					item.icon = 'fad fa-' + item.icon
					item.title = this.searchKeyword ? item.parentName ? `${item.parentName} - ${item.menu}` : item.menu : item.menu
					item.child = item.items
					item.disabled = !item.hasCommercialAccess || item.isDisabled
					item.class = item.hasCommercialAccess ? '' : 'no-access'
					item.attributes = item.isDisabled ? { 'title': this.$t('no-access') } : {}
					if (Array.isArray(item.child)) {
						item.child.forEach(ch => changeFormat(ch))
					}
				}
				items.forEach(ch => changeFormat(ch))
				return items
			},
		},
		created() {
			this.clone()
		},
		mounted() {
			// this.subscribeKeys()
		},
		methods: {
			prepareDynamicRoutes() {
				let preload = Promise.all([
					this.prepareDynamicReportRoutes(),
					this.prepareCustomAccountCrawlingRoutes()
				])

				preload.finally(() => {
					this.sidebarToggler = true
				})
			},
			prepareDynamicReportRoutes() {
				return post(Endpoints.getUrl('reportsDynamic.list')).then(res => {
					let dynamicReports = res.data.items

					for (let report of dynamicReports) {
						if (report.navKey) {
							let routeObj = {
								id: report.id,
								func: () => {
									dynamicReportInstance.launchDynamicReport(report.id, this)
								},
								menu: report.name,
								icon: 'chart-line',
								isDynamicRoute: true
							}

							let target = routes
							for (let item of report.navKey.split('.')) {
								target = target.find(x => x.id === item).items
							}

							target.push(routeObj)
						}
					}
				})
					.catch(() => { })
					.finally(() => {
					})
			},
			prepareCustomAccountCrawlingRoutes() {
				return post(Endpoints.getUrl('customAccountCrawling.list')).then(res => {
					let reports = res.data.items

					for (let report of reports) {
						if (!report.navKey)
							continue

						const route = findRoute('reports.custom-account-crawling-viewer')
						if (!route)
							continue

						let routeObj = _.cloneDeep(route)
						routeObj.id = routeObj.id + report.id
						// console.log("🚀 ~ returnpost ~ routeObj.id:", routeObj.id)
						routeObj.menu = report.name
						routeObj.component = markRaw(routeObj.component)
						routeObj.hidden = false
						routeObj.data = report
						routeObj.options = { autoLoad: true }
						routeObj.isDynamicRoute = true

						let target = routes
						for (let item of report.navKey.split('.')) {
							target = target.find(x => x.id === item).items
						}

						target.push(routeObj)
					}
				})
					.catch(() => { })
					.finally(() => {
					})
			},
			openInitTabs(currentHash) {
				var startups = this.routes.filter((x) => x.startup === true)
				if (startups.length > 0) {
					for (var i = 0; i < startups.length; i++) {
						this.$emit('navigate', startups[i])
					}
				}

				const hash = currentHash || this.hash

				if (hash !== '') {
					let directTab = this.find(hash)
					if (directTab != null) {
						directTab.query = this.$route.query
						this.$emit('navigate', directTab)
					}
				}

			},

			clone() {
				const iterate = (list, parentName = '') => {
					for (var r of list) {
						if (r.menu && r.menu.startsWith('nav.')) {
							r.menu = this.$t(r.menu)
						}

						r.pageTitle = r.pageTitle || r.menu
						if (r.pageTitle.startsWith('nav.')) {
							r.pageTitle = this.$t(r.pageTitle)
						}

						r.href = r.component ? r.id : ''
						r.parentName = parentName

						if (r.items && r.items.length) {
							r.items = r.items.filter(item => !item.isDynamicRoute)
							iterate(r.items, r.pageTitle)
						}
					}
				}

				iterate(this.routes)
			},
			menuFocused() {
				this.isFocused = true
				this.emitFocus(this.selectedItem || _.head(this.filteredRoutes))
			},
			menuBlur() {
				this.isFocused = false
				this.closeMenu()
				this.emitFocus(null)
			},
			toggleCollapsed(event) {
				this.collapsed = !this.collapsed
				this.onToggleCollapse(this.collapsed)
			},
			navigate(route) {
				this.isFocused = false
				this.closeMenu()
				this.emitFocus(null)
				this.$emit('navigate', route)
			},
			closeMenu() {
				this.$emit('openedItemChanged', null)
			},
			openedItemChanged(route) {
				this.$emit('openedItemChanged', route)
			},
			find(hash) {
				const findInChildren = (parent) => {
					if (parent.id === hash) {
						return parent
					} else if (parent.items && parent.items.length) {
						for (let item of parent.items) {
							let result = findInChildren(item)
							if (result != null) {
								return result
							}
						}
					}

					return null
				}

				for (let item of this.routes) {
					let result = findInChildren(item)
					if (result != null) {
						return result
					}
				}

				return null
			},

			emitFocus(item) {
				this.$emit('focusedItemChanged', item)
			},
			findParent(target) {
				const findIn = (item) => {
					if (item === target) {
						return null
					}

					if (item.items) {
						for (let i = 0; i < item.items.length; i++) {
							let current = item.items[i]
							if (current === target) {
								return item
							} else if (current.items && current.items.length) {
								let parent = findIn(current)
								if (parent) {
									return parent
								}
							}
						}
					}

					return null
				}

				for (let i = 0; i < this.filteredRoutes.length; i++) {
					let parent = findIn(this.filteredRoutes[i])
					if (parent) {
						return parent
					}
				}

				return null
			},
			navItemAreEqual(first, second) {
				if (!first ^ !second || !first) {
					return false
				}

				return first.id === second.id
			},
			onToggleCollapse(collapsed) {
				$('#main-sidebar').css('width', collapsed ? '65px' : '230px')
			},
			onItemClick(event, item) {
				if (this.isOpening) return

				this.isOpening = true

				this.isFocused = false
				let route = this.searchInRoutesById(item.id)

				if (route && route.func)
					this.$emit('executeFunction', route)

				else if (route && route.component)
					this.$emit('navigate', route)

				this.defer(() => {
					this.isOpening = false
				}, 500)
			},
			searchInRoutesById(id) {
				const search = (routes) => {
					let route = routes.find(x => x.id === id)
					if (route)
						return route
					route = null
					for (let index = 0; index < routes.length; index++) {
						if (Array.isArray(routes[index].items)) {
							route = search(routes[index].items)
							if (route)
								return route
						}
					}
					return route
				}
				return search(this.routes)
			},
			subscribeKeys() {
				// console.log('subscribeKeys2',this.parentEl())
				// console.log('',this.$keyHandler.Handlers)

				/*this.$keyHandler.Subscribe({*/
				/*	name: `arrow-button-asd65s`,*/
				/*	// keyCode: 40, // 40:arrow-down*/
				/*  keyCode: 40, ctrlKey: true,*/
				/*	el: this.parentEl(),*/
				/*	context: this,*/
				/*	handler: function (sender, e) {*/
				/*    console.log('arrow-down',)*/
				/*		// e.preventDefault()*/
				/*    //*/
				/*		// const focusNextOf = (item) => {*/
				/*		// 	let parent = this.findParent(item)*/
				/*		// 	if (parent) {*/
				/*		// 		let index = parent.items.indexOf(item)*/
				/*		// 		if (index < parent.items.length - 1) {*/
				/*		// 			focusFirstChild(parent.items[index + 1])*/
				/*		// 		} else {*/
				/*		// 			focusNextOf(parent)*/
				/*		// 		}*/
				/*		// 	} else {*/
				/*		// 		for (let i = 0; i < this.filteredRoutes.length; i++) {*/
				/*		// 			if (*/
				/*		// 				this.navItemAreEqual(this.filteredRoutes[i], item) &&*/
				/*		// 				i < this.filteredRoutes.length - 1*/
				/*		// 			) {*/
				/*		// 				focusFirstChild(this.filteredRoutes[i + 1])*/
				/*		// 			}*/
				/*		// 		}*/
				/*		// 	}*/
				/*		// }*/
				/*    //*/
				// 		// const focusFirstChild = (item) => {
				// 		// 	if (
				// 		// 		!item.items ||
				// 		// 		!item.items.length ||
				// 		// 		!this.openedItem ||
				// 		// 		this.openedItem.id !== item.id
				// 		// 	) {
				// 		// 		this.emitFocus(item)
				// 		// 	} else {
				// 		// 		this.emitFocus(item.items[0])
				// 		// 	}
				// 		// }
				//     //
				// 		// if ($(this.$refs.searchInput).is(':focus')) {
				// 		// 	this.$el.focus()
				// 		// 	this.emitFocus(_.head(this.filteredRoutes))
				// 		// } else {
				// 		// 	let targetItem =
				// 		// 		this.focusedItem ||
				// 		// 		this.selectedItem ||
				// 		// 		_.head(this.filteredRoutes)
				// 		// 	if (targetItem) {
				// 		// 		focusNextOf(targetItem)
				// 		// 	}
				// 		// }
				//     //
				// 		// return true
				// 	},
				// })
				// console.log('',this.$keyHandler.Handlers)
			},
		},
	}
</script>
<style>
	.nk-search input {
		background-color: transparent;
		border: none !important;
		outline: none;
		color: #aaa;
	}

	.nk-search input::placeholder {
		color: #aaa;
	}

	.slide-enter-active,
	.slide-leave-active {
		transition: max-height 0.35s;
	}

	.slide-enter,
	.slide-leave-to {
		max-height: 0px;
	}

	.slide-enter-to,
	.slide-leave {
		max-height: 20em;
	}
</style>
